
  export function clearSessionStorage() {
    sessionStorage.removeItem('companyInfo');
    sessionStorage.removeItem('postIncStatus');
    sessionStorage.removeItem('shareholders');
    sessionStorage.removeItem('shareDetails');
    sessionStorage.removeItem('processChargeSatisfaction');



  }
